import React, { useState } from "react";
import { useLocation } from "react-router";

import MobileSideNav from "../mobile-side-nav/mobile-side-nav";

import appLogo from "../../assets/images/Pi-Original.svg";
import Hamburger from "../../assets/images/hamburger.svg";
import "./header.scss";

const Header = () => {
  const [isSidenavOpen, setIsSidenavOpen] = useState(false);
  const location = useLocation();

  const handleSideNav = () => {
    setIsSidenavOpen(!isSidenavOpen);
  };

  return (
    <header className="header_container">
      {isSidenavOpen && (
        <aside
          className={`side-menu__container--toggle ${
            isSidenavOpen && "side-menu__container-active"
          }`}
        >
          <div className="slide-menu">
            <MobileSideNav closeSidenav={handleSideNav} />
          </div>
        </aside>
      )}
      <nav className="header_items">
        <ul className="header_ul">
          <li>
            <img
              src={Hamburger}
              className="hamburger_icon"
              alt="Hamburger icon"
              onClick={handleSideNav}
            />
          </li>
          <li>
            <a
              href="/"
              className={`header_link ${
                location.pathname === "/" && "active-link"
              }`}
            >
              HOME
            </a>
          </li>
          <li>
            <a
              href="/about"
              className={`header_link ${
                location.pathname === "/about" && "active-link"
              }`}
            >
              ABOUT
            </a>
          </li>
          <li>
            <a
              href="/"
              className={`header_link ${
                location.pathname === "/team" && "active-link"
              }`}
            >
              TEAM
            </a>
          </li>
          <li>
            <a
              href="/contact"
              className={`header_link ${
                location.pathname === "/contact" && "active-link"
              }`}
            >
              CONTACT
            </a>
          </li>
          <li>
            <img src={appLogo} className="app_icon" alt="PiRentz logo" />
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
